import React, { useContext, useEffect, useRef, useState } from 'react'
import { Title } from '../../style/style'
import { Link } from 'react-router-dom'
import { AppContext } from '../../App'
import { Modal } from 'antd'
import { getRequest } from '../../request/request'
import { errors } from '../../function/errors'
import { useTranslation } from 'react-i18next'
import './style/HuntingFarm.scss'
import { ContextType } from '../../type/type'
import { ReactComponent as MapIcon } from '../../static/map/map.svg'

const HuntingFarm = () => {
  const { t } = useTranslation()
  const svgEl: any = useRef(null)
  const mapText: any = useRef(null)
  const [text, setText] = useState('')
  const [id, setId] = useState('')
  const [data, setData] = useState<any>(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { state } = useContext<ContextType>(AppContext)
  // const listRegion: any = listCity(t)

  useEffect(() => {
    const arrMap = svgEl.current.querySelectorAll('.reg')
    arrMap.forEach((e: any, index: number) => {
      arrMap[index].classList.remove('active')
    })
    setData(null)
  }, [state.lang])

  const handleMap = (e: any): void => {
    setData(null)
    const arrMap = svgEl.current.querySelectorAll('.reg')
    const target = e.target

    if (target.id !== 'map') {
      getRequest(`/maps/additional_info/${target.id}/get_info/`)
        .then((res) => {
          console.log('res?.data', res?.data)
          setData(res?.data)
        })
        .catch((err) => {
          errors(err)
        })
    }

    arrMap.forEach((e: any, index: number): void => {
      if (target.id === 'map' || target.className.baseVal === 'obl') {
        setId('')
        arrMap[index].classList.remove('active')
        return
      }
      /*goUp()*/
      e.id !== 'map' && target.id === e.id
        ? (arrMap[index].classList.add('active'), setId(e.id))
        : arrMap[index].classList.remove('active')
    })
  }

  const handleHover = (e: any): void => {
    const {
      target: { id },
    } = e

    if (id !== 'map' && id !== '') {
      getRequest(`/maps/additional_info/${id}/get_info/`)
        .then((res) => {
          setText(res?.data?.map?.title)
        })
        .catch((err) => {
          errors(err)
        })
    }
  }

  const handleMove = (e: any) => {
    const target = e.target
    const shift = 5
    const x = e.clientX + shift
    const y = e.clientY - 40

    if (target.className.baseVal === 'reg') {
      mapText.current.style.left = `${x}px`
      mapText.current.style.top = `${y}px`
      mapText.current.classList.add('visible')
      return
    }

    mapText.current.classList.remove('visible')
  }

  const additionInfo = (id: string) => (
    <div className={`addition-maps-info ${data ? 'active' : ''}`}>
      {data && id && (
        <>
          <p>{data?.map?.title || ''}</p>
          <p>
            <span className="href" onClick={showModal}>
              {t('h11')}
            </span>
          </p>
          <p>
            <span className="href">
              <Link to={`/hunting/map/${id}`}>{t('h12')}</Link>
            </span>
          </p>
        </>
      )}
    </div>
  )

  const showModal = () => setIsModalVisible(true)

  const handleOk = () => setIsModalVisible(false)

  const handleCancel = () => setIsModalVisible(false)

  return (
    <>
      <Title className="title">{t('h13')}</Title>

      {data && (
        <Modal
          title={t('h11')}
          okButtonProps={{
            style: {
              display: 'none',
            },
          }}
          cancelText={t('h15')}
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <p>
            <strong>{t('h16')}:</strong> {data?.address}
          </p>
          <p>
            <strong>{t('h17')}:</strong> {data.contacts}
          </p>
          <p>
            <strong>{t('h18')}:</strong> {data.hunting_area}
          </p>
          <p>
            <strong>{t('h19')}:</strong> {data.main_water}
          </p>
          <p>
            <strong>{t('h20')}:</strong> {data.types_of_hunting}
          </p>
        </Modal>
      )}

      {additionInfo(id)}

      <div style={{ position: 'relative' }} onMouseMove={handleMove}>
        <MapIcon
          id="map"
          ref={svgEl}
          onClick={handleMap}
          onMouseOver={handleHover}
          onMouseOut={() => mapText.current.classList.remove('visible')}
        />
        <div className="map-text" ref={mapText}>
          {text}
        </div>
      </div>
    </>
  )
}

export default HuntingFarm
